import { createSlice } from '@reduxjs/toolkit';
import { FTATypeType } from 'types/ftaType';

interface FTATypeState {
  ftaType: FTATypeType;
}

const initialState: FTATypeState = {
  ftaType: {} as FTATypeType,
};

const ftaTypeSlice = createSlice({
  name: 'ftaType',
  initialState,
  reducers: {
    setOneFTAType(state, action) {
      state.ftaType = action.payload;
    },
  },
});

export const { setOneFTAType } = ftaTypeSlice.actions;
export default ftaTypeSlice.reducer;
